'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
require('../typography/ErrorText/ErrorText.js');
require('../typography/LargeDarkText/LargeDarkText.js');
require('../typography/LargeEmphasizedWhiteText/LargeEmphasizedWhiteText.js');
require('../typography/MediumDarkText/MediumDarkText.js');
var MediumEmphasizedDarkText = require('../typography/MediumEmphasizedDarkText/MediumEmphasizedDarkText.js');
require('../typography/MediumText/MediumText.js');
require('../typography/MediumWhiteText/MediumWhiteText.js');
require('../typography/MiniatureLinkText/MiniatureLinkText.js');
require('../typography/SmallDarkText/SmallDarkText.js');
require('../typography/SmallDarkTextHeavy/SmallDarkTextHeavy.js');
require('../typography/SmallDisabledText/SmallDisabledText.js');
require('../typography/SmallEmphasizedDarkText/SmallEmphasizedDarkText.js');
require('../typography/SmallEmphasizedDisabledText/SmallEmphasizedDisabledText.js');
require('../typography/SmallEmphasizedLinkText/SmallEmphasizedLinkText.js');
require('../typography/SmallLinkText/SmallLinkText.js');
require('../typography/SmallTitleText/SmallTitleText.js');
require('../typography/SmallWhiteText/SmallWhiteText.js');
require('../typography/TinyDarkText/TinyDarkText.js');
require('../typography/TinyEmphasizedDarkText/TinyEmphasizedDarkText.js');
require('../typography/TinyLinkText/TinyLinkText.js');
require('../typography/TinyTitleText/TinyTitleText.js');
require('../typography/XXLargeDarkText/XXLargeDarkText.js');
var Grid = _interopDefault(require('@material-ui/core/Grid'));
var SelectWithLabel = require('../inputs/SelectWithLabel/SelectWithLabel.js');
var InputWithIcon = require('../inputs/InputWithIcon/InputWithIcon.js');
var ChatInput = require('./components/ChatInput/ChatInput.js');
var ConversationScrollContainer = require('./components/ConversationScrollContainer/ConversationScrollContainer.js');
require('./components/ConversationCard/ConversationCard.js');
require('./components/SelectConversationListElement/SelectConversationListElement.js');
var SelectConversationList = require('./components/SelectConversationList/SelectConversationList.js');
var styledComponents = require('./styled-components.js');

var ConversationList = function (props) {
    var _a = React__default.useState(''), conversationGroup = _a[0], setConversationGroup = _a[1];
    var _b = props.getMore, getMore = _b === void 0 ? function () { return Promise.resolve(false); } : _b, _c = props.messages, messages = _c === void 0 ? [] : _c, pollForMore = props.pollForMore, getMoreContacts = props.getMoreContacts, contactChange = props.contactChange, searchByName = props.searchByName, changeFilter = props.changeFilter, updateReadState = props.updateReadState, deleteConversation = props.deleteConversation, handleSend = props.handleSend;
    React.useEffect(function () {
        var current = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return function () {
            document.body.style.overflow = current;
        };
    });
    var handleSelect = function (conversation) {
        setConversationGroup(conversation.contact.name);
        contactChange(conversation);
    };
    var handleSearchChange = function (e) {
        searchByName(e.target.value);
    };
    var handleRead = function (read, id) {
        updateReadState(read, id);
    };
    var handleDelete = function (id) {
        deleteConversation(id);
    };
    // TODO: internationalization
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Grid, { container: true },
            React__default.createElement(Grid, { xs: 3, item: true, style: { borderRight: '1px solid lightgrey', height: '101vm' } },
                React__default.createElement(InputWithIcon, { title: 'Search by name', onChange: handleSearchChange }),
                React__default.createElement(SelectWithLabel, { menuItems: [
                        { value: '1', display: 'Filter by User', disabled: true },
                        { value: '2', display: 'second', disabled: false },
                        { value: '3', display: 'third', disabled: true },
                    ], defaultValue: '1', title: '', reporter: changeFilter }),
                React__default.createElement(SelectConversationList, { getMore: getMoreContacts, onDelete: handleDelete, onMarkRead: handleRead, onSelect: handleSelect })),
            React__default.createElement(Grid, { xs: 9, item: true, style: { backgroundColor: '#F6F8FC' } },
                React__default.createElement(styledComponents.FlexColumnContainer, null,
                    React__default.createElement(styledComponents.ExpansionContainer, { style: { backgroundColor: 'white', padding: '20px' } },
                        React__default.createElement(MediumEmphasizedDarkText, { align: 'center' }, conversationGroup)),
                    React__default.createElement(ConversationScrollContainer, { messages: messages, getMore: getMore, pollForMore: pollForMore }),
                    React__default.createElement(styledComponents.ExpansionContainer, { style: { marginBottom: '20px' } },
                        React__default.createElement(ChatInput, { onSend: handleSend })))))));
};

module.exports = ConversationList;
